import React, { useEffect, useRef, useState } from "react";
import ICONS from "../../../../assets/Icons";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import AssociatedAccountCard from "../../../../components/_utils/AccountCreationComponents/AssociatedAccountCard";
import { useNavigate } from "react-router-dom";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import CommonToast from "../../../../components/_utils/CommonToast";

const AssociateAccountBankEdit = ({
  ActiveData,
  DeactiveData,
  haveAcheived,
  haveDennied,
  haveBlock,
  haveRejected,
  isApprovedState,
  haveApproved,
  havePending,
  isActive,
  activeTab,
  slideDirection,
  setSlideDirection,
  previousId,
  addSpacesToNumber,
  details,
  isBankLinkedAccount,
  payload,
  beneLookLoading,
  type,
  setAccountId,
  setAccoutDetails,
}) => {
  const navigate = useNavigate();
  const isFirstRender = useRef(true);
  const [animate, setAnimate] = useState(false);
  const [prevTab, setPrevTab] = useState("Active");
  const scrollRef = useRef(null);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (scrollRef.current) {
      scrollRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }

    setAnimate(true);

    if (prevTab === "Active" && activeTab === "Inactive") {
      setSlideDirection("right");
    } else if (prevTab === "Inactive" && activeTab === "Active") {
      setSlideDirection("left");
    }

    setPrevTab(activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setAnimate(true);
    if (prevTab === "Active" && activeTab === "Inactive") {
      setSlideDirection("right");
    } else if (prevTab === "Inactive" && activeTab === "Active") {
      setSlideDirection("left");
    }

    setPrevTab(activeTab);
  }, [activeTab]);

  const detailNavigate = (id) => {
    if (type === "field_force") {
      CommonToast({
        text: "Feature coming soon",
        icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
        variant: "var(--coming-soon)",
        buttonNeeded: false,
      });
    } else {
      setAccoutDetails(true);
      setAccountId(id);
    }
  };

  return (
    <>
      <div
        className={`py-padding-md pl-padding-md  bg-primary-card flex flex-col ${
          details ? " h-auto" : "h-associated-popup-height"
        } rounded-border-radius-md relative z-z-index-base`}
      >
        <style>
          {`
          @keyframes slideInFromRight {
            from {
              transform: translateX(100%);
              opacity: var(--opacity-none);
            }
            to {
              transform: translateX(0);
              opacity: var(--base-opacity);
            }
          }

          @keyframes slideInFromLeft {
            from {
              transform: translateX(-100%);
              opacity: var(--opacity-none);
            }
            to {
              transform: translateX(0);
              opacity: var(--base-opacity);
            }
          }

          .animate-slideInFromRight {
            animation: slideInFromRight var(--animation-fast-s) ease-in-out forwards;
          }

          .animate-slideInFromLeft {
            animation: slideInFromLeft var(--animation-fast-s) ease-in-out forwards;
          }
        `}
        </style>

        <div className="pr-padding-md">
          <p className="text-font-md text-text-primary font-semibold">
            Associated Accounts
          </p>
        </div>

        {details && !beneLookLoading ? (
          <>
            <div className="mt-margin-sm pr-padding-md">
              <p className="text-text-primary text-font-sm font-semibold">
                No associated accounts found
              </p>
              <p className="text-text-secondary text-font-xs font-normal">
                There are no existing accounts that are associated with the bank
                details provided. You can proceed to create a new account.
              </p>
            </div>
          </>
        ) : (
          <>
            <div className=" mr-margin-md">
              <p className="text-font-xs text-text-secondary font-normal mt-margin-xs">
                The following existing accounts are associated with the bank
                provided.
              </p>
            </div>

            <div className="  mt-margin-md pb-padding-sm">
              <SwitcherTabs
                tabs={[
                  { label: "Active", key: "Active", handler: ActiveData },
                  { label: "Inactive", key: "Inactive", handler: DeactiveData },
                ]}
                swicherTabBgColor={"var(--primary-nav"}
                initialActiveTab={"Active"}
              />
            </div>

            <div
              ref={scrollRef}
              className="relative overflow-hidden flex-1 overflow-y-auto"
            >
              <div
                key={activeTab}
                className={`absolute inset-0 transition-transform duration-animation-fast ease-in-out ${
                  animate
                    ? slideDirection === "right"
                      ? "animate-slideInFromRight"
                      : "animate-slideInFromLeft"
                    : ""
                } `}
              >
                {activeTab === "Inactive" ? (
                  <div className=" flex flex-col gap-gap-sm">
                    {haveAcheived ||
                    haveDennied ||
                    haveBlock ||
                    haveRejected ? (
                      <>
                        {(haveDennied || haveRejected) && (
                          <div>
                            <div className="mb-margin-sm">
                              <p className="text-font-xs text-text-primary font-normal">
                                Rejected accounts
                              </p>
                            </div>

                            <div className=" flex flex-col gap-gap-sm">
                              {isApprovedState?.map((val, i) => {
                                if (
                                  val?.approval_status === "rejected" ||
                                  val?.approval_status === "denied"
                                ) {
                                  return (
                                    <div className=" mr-margin-md">
                                      <AssociatedAccountCard
                                        key={i}
                                        TitleName={val?.name}
                                        SubTitleName={` ${val?.pan_no} - PAN number`}
                                        TitleNameColour={
                                          (val?.approval_status ===
                                            "rejected" ||
                                            val?.approval_status ===
                                              "denied") &&
                                          "failed"
                                        }
                                        BorderColour={
                                          isBankLinkedAccount
                                            ? payload?.pan_no == val?.pan_no &&
                                              payload?.bank_account ==
                                                val?.bank_acc_no &&
                                              payload?.ifsc_code ==
                                                val?.ifsc_code
                                              ? true
                                              : false
                                            : null
                                        }
                                        pointerEvent={
                                          previousId === val?.id
                                            ? "none"
                                            : "auto"
                                        }
                                        TitleAccountTextSize="font-md"
                                        TitleAccountFontWeight="normal"
                                        SubTitleNameColour="text-secondary"
                                        SubTitleAccountTextSize="font-xs"
                                        SubTitleAccountFontWeight="normal"
                                        RightDivIcon={ICONS?.VIEW_DETAILS}
                                        CardOpacity={
                                          previousId === val?.id
                                            ? "var(--light-opacity)"
                                            : "var(--base-opacity)"
                                        }
                                        viewdetailsData={() => {
                                          detailNavigate(val?.id);
                                        }}
                                      />
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        )}
                        {haveBlock && (
                          <div>
                            <div className="mb-margin-sm">
                              <p className="text-font-xs text-text-primary font-normal">
                                Blocked accounts
                              </p>
                            </div>
                            <div className=" flex flex-col gap-gap-sm">
                              {isApprovedState?.map((val, i) => {
                                if (val?.approval_status === "blocked") {
                                  return (
                                    <div className=" mr-margin-md">
                                      <AssociatedAccountCard
                                        key={i}
                                        TitleName={val?.name}
                                        SubTitleName={` ${val?.pan_no} - PAN number`}
                                        TitleNameColour={
                                          val?.approval_status === "blocked" &&
                                          "failed"
                                        }
                                        BorderColour={
                                          isBankLinkedAccount
                                            ? payload?.pan_no == val?.pan_no &&
                                              payload?.bank_account ==
                                                val?.bank_acc_no &&
                                              payload?.ifsc_code ==
                                                val?.ifsc_code
                                              ? true
                                              : false
                                            : null
                                        }
                                        CardOpacity={
                                          previousId === val?.id
                                            ? "var(--light-opacity)"
                                            : "var(--base-opacity)"
                                        }
                                        pointerEvent={
                                          previousId === val?.id
                                            ? "none"
                                            : "auto"
                                        }
                                        TitleAccountTextSize="font-md"
                                        TitleAccountFontWeight="normal"
                                        SubTitleNameColour="text-secondary"
                                        SubTitleAccountTextSize="font-xs"
                                        SubTitleAccountFontWeight="normal"
                                        RightDivIcon={ICONS?.VIEW_DETAILS}
                                        viewdetailsData={() => {
                                          detailNavigate(val?.id);
                                        }}
                                      />
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        )}
                        {haveAcheived && (
                          <div>
                            <div className="mb-margin-sm">
                              <p className="text-font-xs text-text-primary font-normal">
                                Archived accounts
                              </p>
                            </div>

                            <div className=" flex flex-col gap-gap-sm">
                              {isApprovedState?.map((val, i) => {
                                if (val?.approval_status === "archived") {
                                  return (
                                    <div className=" mr-margin-md">
                                      <AssociatedAccountCard
                                        key={i}
                                        TitleName={val?.name}
                                        SubTitleName={` ${val?.pan_no} - PAN number`}
                                        TitleNameColour={
                                          val?.approval_status === "archived" &&
                                          "abandoned"
                                        }
                                        BorderColour={
                                          isBankLinkedAccount
                                            ? payload?.pan_no == val?.pan_no &&
                                              payload?.bank_account ==
                                                val?.bank_acc_no &&
                                              payload?.ifsc_code ==
                                                val?.ifsc_code
                                              ? true
                                              : false
                                            : null
                                        }
                                        CardOpacity={
                                          previousId === val?.id
                                            ? "var(--light-opacity)"
                                            : "var(--base-opacity)"
                                        }
                                        pointerEvent={
                                          previousId === val?.id
                                            ? "none"
                                            : "auto"
                                        }
                                        TitleAccountTextSize="font-md"
                                        TitleAccountFontWeight="normal"
                                        SubTitleNameColour="text-secondary"
                                        SubTitleAccountTextSize="font-xs"
                                        SubTitleAccountFontWeight="normal"
                                        RightDivIcon={ICONS?.VIEW_DETAILS}
                                        viewdetailsData={() => {
                                          detailNavigate(val?.id);
                                        }}
                                      />
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className=" mt-margin-md pr-padding-md">
                        <p className=" text-text-secondary text-font-sm font-semibold ">
                          No inactive associated accounts found
                        </p>
                        <p className="text-text-secondary text-font-xs font-normal">
                          There are no existing inactive accounts that are
                          associated with the bank provided.
                        </p>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="flex flex-col gap-gap-sm">
                    {haveApproved || havePending ? (
                      <>
                        {haveApproved && (
                          <div>
                            <div className="mb-margin-sm">
                              <p className="text-font-xs text-text-primary font-normal">
                                Approved accounts
                              </p>
                            </div>
                            <div className=" flex flex-col gap-gap-sm">
                              {isApprovedState?.map((val, i) => {
                                if (val?.approval_status === "approved") {
                                  return (
                                    <div className=" mr-margin-md ">
                                      <AssociatedAccountCard
                                        key={i}
                                        TitleName={val?.name}
                                        SubTitleName={` ${val?.pan_no} - PAN number`}
                                        TitleNameColour={"settled"}
                                        BorderColour={
                                          isBankLinkedAccount
                                            ? payload?.pan_no == val?.pan_no &&
                                              payload?.bank_account ==
                                                val?.bank_acc_no &&
                                              payload?.ifsc_code ==
                                                val?.ifsc_code
                                              ? true
                                              : false
                                            : null
                                        }
                                        CardOpacity={
                                          previousId === val?.id
                                            ? "var(--light-opacity)"
                                            : "var(--base-opacity)"
                                        }
                                        pointerEvent={
                                          previousId === val?.id
                                            ? "none"
                                            : "auto"
                                        }
                                        TitleAccountTextSize="font-md"
                                        TitleAccountFontWeight="normal"
                                        SubTitleNameColour="text-secondary"
                                        SubTitleAccountTextSize="font-xs"
                                        SubTitleAccountFontWeight="normal"
                                        RightDivIcon={ICONS?.VIEW_DETAILS}
                                        viewdetailsData={() => {
                                          detailNavigate(val?.id);
                                        }}
                                      />
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        )}
                        {havePending && (
                          <div>
                            <div className="mb-margin-sm">
                              <p className="text-font-xs text-text-primary font-normal">
                                Pending accounts
                              </p>
                            </div>
                            <div className=" flex flex-col gap-gap-sm">
                              {isApprovedState?.map((val, i) => {
                                if (val?.approval_status === "pending") {
                                  return (
                                    <div className=" mr-margin-md">
                                      <AssociatedAccountCard
                                        key={i}
                                        TitleName={val?.name}
                                        SubTitleName={` ${val?.pan_no} - PAN number`}
                                        TitleNameColour={
                                          val?.approval_status === "pending" &&
                                          "pending"
                                        }
                                        BorderColour={
                                          isBankLinkedAccount
                                            ? payload?.pan_no == val?.pan_no &&
                                              payload?.bank_account ==
                                                val?.bank_acc_no &&
                                              payload?.ifsc_code ==
                                                val?.ifsc_code
                                              ? true
                                              : false
                                            : null
                                        }
                                        CardOpacity={
                                          previousId === val?.id
                                            ? "var(--light-opacity)"
                                            : "var(--base-opacity)"
                                        }
                                        pointerEvent={
                                          previousId === val?.id
                                            ? "none"
                                            : "auto"
                                        }
                                        TitleAccountTextSize="font-md"
                                        TitleAccountFontWeight="normal"
                                        SubTitleNameColour="text-secondary"
                                        SubTitleAccountTextSize="font-xs"
                                        SubTitleAccountFontWeight="normal"
                                        RightDivIcon={ICONS?.VIEW_DETAILS}
                                        viewdetailsData={() => {
                                          detailNavigate(val?.id);
                                        }}
                                      />
                                    </div>
                                  );
                                }
                              })}
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className=" mt-margin-md pr-padding-md">
                        <p className=" text-text-secondary text-font-sm font-semibold ">
                          No active associated accounts found
                        </p>
                        <p className="text-text-secondary text-font-xs font-normal">
                          here are no existing active accounts that are
                          associated with the bank provided.
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default AssociateAccountBankEdit;
